
import { BigDecimal } from "@pcgerente-node/pcg-comun";
import { logistica_MANIFIESTO_PROFORMA, logistica_MANIFIESTO_PROFORMA_DETALLE } from "@pcgerente-node/pcg-comun/dist/DTOs";
import {IApiResponse} from "@pcgerente-node/pcg-comun";
import axios, { AxiosResponse } from "axios";
import { useState } from "react";
import { baseURL, headers } from "../../../../redux/helpersRedux";
import { StyleProps10, StyleProps11, StyleProps6, StyleProps7, StyleProps8, StyleProps9 } from "../../../Crear/PrevisualizarGuiaProforma/styles";
import ModalAnularManifiesto from "./ModalAnularManifiesto/ModalAnularManifiesto";

const StyleProps20: React.CSSProperties = {
    padding: "4px 5px",
    textAlign: "left",
    minHeight: "auto"
}

interface childsProps {
    manifiestosProforma: logistica_MANIFIESTO_PROFORMA_DETALLE[]
}

const GuiaIndv: React.FC<childsProps> = ({ manifiestosProforma }) => {
    
    let total = new BigDecimal(manifiestosProforma[0]?.logistica_GUIA_PROFORMA?.total)
    const [mensajeAnulacion,setMensajeAnulacion] = useState("")
    return (
            <>
                <div className="inv--product-table-section">
                    <div className="table-responsive">
                        <table id="default-ordering" className="table" >
                            <thead >
                                <tr style={StyleProps7}>
                                    <th scope="col" style={StyleProps6}>ID</th>
                                    <th scope="col" style={StyleProps6}>#Guia</th>
                                    <th scope="col" style={StyleProps6}>Doc</th>
                                    <th scope="col" style={StyleProps6}>Remitente</th>
                                    <th scope="col" style={StyleProps6}>Destinatario</th>
                                    <th scope="col" style={StyleProps6}>Cantidad</th>
                                    <th scope="col" style={StyleProps6}>Total</th>
                                    <th scope="col" style={StyleProps6}>Destino</th>
                                </tr>
                            </thead>
                            <tbody className="table group-divider">
                                {manifiestosProforma.length ?
                                    manifiestosProforma.map((mp, i) =>
                                        <tr key={i} style={StyleProps8}>
                                            {mp.logistica_GUIA_PROFORMA?
                                            <>
                                                <td style={StyleProps20}>{mp.idGuiaProforma} </td>
                                                <td style={StyleProps20}>{`${mp.logistica_GUIA_PROFORMA.serie1}-${mp.logistica_GUIA_PROFORMA.serie2}-${mp.logistica_GUIA_PROFORMA.numeroDocumento}`} </td>
                                                <td style={StyleProps20}>{`Guia`} </td>
                                                <td style={StyleProps20}>{`${mp.logistica_GUIA_PROFORMA.CLIENTE_REMITENTE?.razonSocial}`}</td>
                                                <td style={StyleProps20}>{`${mp.logistica_GUIA_PROFORMA.CLIENTE_DESTINATARIO?.razonSocial|| "NA"}`}</td>
                                                <td style={StyleProps20}>{`${ new BigDecimal(mp.logistica_GUIA_PROFORMA.cantidad).toString()}`}</td>
                                                <td style={StyleProps20}>{`$${new BigDecimal(mp.logistica_GUIA_PROFORMA.total).toString()}`}</td>
                                                <td style={StyleProps20}>{`${mp.logistica_GUIA_PROFORMA.CIUDAD_DESTINO?.nombre}`}</td>
                                            </>
                                            : <></>
                                            }
                                        </tr>
                                    )
                                    : <></>
                                }
                                <tr>
                                    <td ></td>
                                    <td style={StyleProps9}>{manifiestosProforma.length}</td>
                                    <td style={StyleProps10}>← TOTAL GUIAS</td>
                                    <td ></td>

                                    <td style={StyleProps11}> TOTAL →</td>
                                    <td style={StyleProps9}>${total.toString()}</td>

                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="invoice-action-btn d-flex justify-content-around">
                         <div>
                            <button
                                onClick={() => handlePrint()}
                                className="btn btn-secondary btn-print action-print"
                                id={"printBtnResumen"}
                            >
                                Imprimir
                            </button>
                        </div>
                       
                        {mensajeAnulacion.length===0 && manifiestosProforma[0].logistica_MANIFIESTO_PROFORMA?.estado === "P"?
                            <ModalAnularManifiesto 
                                manifiestoProformaDetalle={manifiestosProforma[0]}
                                setMensajeAnulacion={setMensajeAnulacion}
                                handleAnularResumen={handleAnularResumen}
                            />
                            :
                            <button 
                                className="btn btn-danger" 
                                id="btnAnularResumen"
                                disabled >
                                Anular Resumen
                            </button>
                            }
                </div>
                <div className="mt-4 text-center">
                    <label id="msgAnulacionResumenDeGuias" className={mensajeAnulacion.includes("Error")? "text-danger": "text-success" }>
                        {mensajeAnulacion}
                    </label>
                </div>
            </>
    )

async function handleAnularResumen(idManifiestoProforma: number){
    const response  = await axios.put(`${baseURL}logistica_MANIFIESTO_PROFORMA/${idManifiestoProforma}`,null,headers)
    .then((res:AxiosResponse<IApiResponse<logistica_MANIFIESTO_PROFORMA>>) => res.data)
    if(response.error){
        setMensajeAnulacion(`Error: ${response.error} `)
    }else {
        setMensajeAnulacion("El resumen de guias ha sido anulado")
    }
    return true
}
function handlePrint(){
    const button = window.document.getElementById('printBtnResumen');
    const btnAnular = window.document.getElementById('btnAnularResumen');
    const labelError = window.document.getElementById('msgAnulacionResumenDeGuias');
    try {
        if (button && btnAnular) {
            button.style.display = 'none';
            btnAnular.style.display = 'none'
        }
        if(labelError){
            labelError.style.display = 'none'
        }
            window.print()        
    } catch (error) {
        if(error instanceof Error)
            setMensajeAnulacion(error.message)
    } finally{
        if (button && btnAnular) {
            button.style.display = 'inline-block';
            btnAnular.style.display = 'inline-block'
        }
        if(labelError){
            labelError.style.display = 'inline-block'
        }
    }
}
}


export default GuiaIndv

